module.exports = __webpack_public_path__ + "img/br48.545ebbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br48.jpg
// module id = 5W9+
// module chunks = 0